import React from 'react';

// SegmentedControl (fase 3, §14) — substitui os antigos checkboxes soltos
// de filtro ("☐ Mostrar arquivadas", "☐ Em atraso") por um controle
// segmentado explícito. Um checkbox solto não comunica o que a lista
// mostra quando desmarcado; o rótulo do segmento ativo sempre deixa isso
// claro (ex.: "Ativas" vs "Todas").
export function SegmentedControl({ options, value, onChange, size = 'md' }) {
  return (
    <div className={`crm-segmented crm-segmented-${size}`} role="tablist">
      {options.map((opt) => (
        <button
          key={String(opt.value)}
          type="button"
          role="tab"
          aria-selected={value === opt.value}
          className={`crm-segmented-item${value === opt.value ? ' active' : ''}`}
          onClick={() => onChange(opt.value)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}

export default SegmentedControl;
